export class Lead {
  constructor() {
    //console.log('class Lead');
  }

  //�������� ������ popup
  sendZayav1(parent) {
    //console.log(this.formValidation(parent), "this.formValidation(parent)");
    if (this.formValidation(parent)) {
      //console.log(parent, "parent", "lid");
      this.send(parent, 10, "lid", "");
      return false;
    }
  }
  //����� ������������
  sendZayav2(parent) {
    if (this.formValidation(parent)) {
      this.send(parent, 10, "cons", "");
      return false;
    }
  }
  //���������� ������ popup
  sendZayav3(parent) {
    if (this.formValidation(parent)) {
      this.send(parent, 10, "order", "");
      return false;
    }
  }
  //����������� popup
  sendZayav4(parent, data) {
    let newData = data
      .filter((item) => item.value != "")
      .map((item) => item.name + ": " + item.value);
    this.send(parent, 10, "calc", newData.join(", <br/>"));
    return false;
  }

  hidePopup() {
    //-console.log("hide popup");
    $(".popup-callback__step--1").css("display", "none");
    $(".popup-callback__step--2").css("display", "block");

    setTimeout(() => {
      $(".popup").removeClass("active");
      $("body").removeClass("no-scroll");
    }, 2000);
    setTimeout(() => {
      $(".popup-callback__step--1").css("display", "block");
      $(".popup-callback__step--2").css("display", "none");
    }, 3000);
  }

  send(parent, mid, leadName, data = "") {
    //-console.log(parent, mid, leadName, "args");
    let el = $(parent);
    let submit = el.find("button[type='submit']");
    let _this = this;
    //-console.log("send");

    $(document).css("cursor", "wait");

    $.ajax({
      url: "/ajax.php?mid=" + mid,
      type: "POST",
      data:
        el.serialize() +
        "&htm_calc=" +
        data +
        "&str_page=" +
        document.title +
        "&mode=send_request",
      dataType: "json",
      beforeSend: function () {
        submit.prop("disabled", true);
      },
      success: function (res) {
        //console.log(res, "response if success");
        if (res["success"]) {
          submit.prop("disabled", true);
          $(".form").trigger("reset");

          //console.log("success, form reset");

          // Отправка события в Яндекс.Метрику при успешной отправке формы
          if (typeof ym !== 'undefined') {
            try {
              ym(103738451, 'reachGoal', 'ORDER');
            } catch (e) {
              console.warn("Ошибка отправки события в Яндекс.Метрику:", e);
            }
          }

          if (leadName == "lid") {
            _this.hidePopup();
          } else if (leadName == "cons") {
            $(".application__form-success").addClass("active");
            $("body").addClass("no-scroll");
            setTimeout(() => {
              $(".application__form-success").removeClass("active");
              $("body").removeClass("no-scroll");
            }, 2000);
          } else if (leadName == "order") {
            _this.hidePopup();
          } else if (leadName == "calc") {
            _this.hidePopup();
            $(".calculator-form__price-value").html("0.00&#8381;");
            calculator.delete(
              $('.calculator-form__size-item:not(":first-of-type")')
            );
            el.attr("onsubmit", `lead.sendZayav1(this); return false;`);
          }

          $(document).css("cursor", "auto");
        } else {
          alert(
            "������: " +
              res["error"] +
              ". ����������, ��������� ������� ��� ��������� � ����. �������� ��������� �� ����������."
          );
          $(document).css("cursor", "auto");
        }
        submit.prop("disabled", false);
      },
      error: function (e) {
        console.log(e, "error response");
      },
    });
  }

  // Валидация имени
  nameValidation(name, nameFieldMistake, nameField) {
    if (name.length < 1) {
      nameFieldMistake.text("Пожалуйста, введите имя.").show();
      nameField.addClass("is-invalid");
      return false;
    } else {
      nameFieldMistake.hide();
      nameField.removeClass("is-invalid");
      return true;
    }
  }

  // Валидация номера телефона
  phoneNumberValidation(phoneNumber, phoneFieldMistake, phoneField) {
    // Регулярное выражение для формата +7 (999)-999-99-99
    let phonePattern = /^\+7\s\(\d{3}\)-\d{3}-\d{2}-\d{2}$/;

    if (!phonePattern.test(phoneNumber)) {
      phoneFieldMistake
        .text("Пожалуйста, введите корректный номер телефона.")
        .show();
      //console.log("Номер телефона введен не верно");
      phoneField.addClass("is-invalid");
      return false;
    } else {
      //console.log("Номер телефона введен верно");
      phoneField.removeClass("is-invalid");
      phoneFieldMistake.hide();
      return true;
    }
  }

  // Валидация согласия
  agreeValidation(agree, agreeFieldMistake) {
    if (!agree.prop("checked")) {
      agreeFieldMistake
        .text("Необходимо ваше согласие на обработку персональных данных.")
        .show();

      return false;
    } else {
      agreeFieldMistake.hide();
      return true;
    }
  }

  // Валидация формы
  formValidation(form) {
    let phoneField = $(form).find('input[type="tel"]');
    let phoneNumber = phoneField.val();
    let phoneFieldMistake = phoneField
      .closest(".form__item")
      .find(".form__item-mistake");

    let nameField = $(form).find('input[name="str_name"]');
    let name = nameField.val();
    let nameFieldMistake = nameField
      .closest(".form__item")
      .find(".form__item-mistake");

    let agreeField = $(form).find('input[name="form-agree"]');
    let agreeFieldMistake = agreeField
      .closest(".form__item")
      .find(".form__item-mistake");

    return (
      this.nameValidation(name, nameFieldMistake, nameField) &&
      this.phoneNumberValidation(phoneNumber, phoneFieldMistake, phoneField) &&
      this.agreeValidation(agreeField, agreeFieldMistake)
    );
  }
}
